import { makeStyles } from "@material-ui/core/styles";

export const PlanFlagStyles = makeStyles((theme) => ({
  flag: {
    clipPath:
      "polygon(20% 0%, 80% 0%, 100% 0, 100% 67%, 54% 100%, 51% 100%, 0 66%, 0 0)",
    width: "65px",
    height: "90px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column-reverse",
    [theme.breakpoints.down("sm")]: {
      width: "45px",
      height: "76px",
    },
  },
}));
